const responses = [
    {id: 3, title: 'Card Lookup Response'},
    {id: 4, title: '3DS Authentication Response'},
    {id: 5, title: 'Cavv Lookup Response'},
    {id: 8, title: 'Cavv Purchase Response'},
    {id: 9, title: 'Cavv Pre-Auth Response'},
    {id: 10, title: 'Res Cavv Purchase Response'},
    {id: 11, title: 'Res Cavv Pre-Auth Response'},
    {id: 12, title: 'Cavv Purchase Recur Response'}
]

export default responses